import Component from "vue-class-component";
import ClientListAbstract from "@/components/ClientAbstract/ClientListAbstract";
import ClientTableElement from '@/components/ClientTableElement/ClientTableElement.vue';
import REQ_URL from '@/consts/req-url';

@Component({
    components: {
        ClientTableElement
    }
})
export default class ClientTable extends ClientListAbstract {
    headers = [
        {
            text: "",
            sortable: false,
            width: 36
        },
        {
            text: "Наименование",
            sortable: false
        },
        {
            text: "1C ID",
            sortable: false
        },
        {
            text: "E-mail",
            sortable: false
        },
        {
            text: "Телефон",
            sortable: false
        },
        {
            text: "Скидка",
            sortable: false,
            align: "center"
        },
        {
            text: "Отсрочка",
            sortable: false,
            align: "center"
        },
        {
            text: "",
            sortable: false,
        }
    ];
    get filteredHeaders() {
        return this.headers;
    }
}